<template>
    <v-app class="vapp planning-v3">
        <HoverTooltip
            :event="hoverEvent"
            :rect="hoverRect"
            :visible="hoverVisible"
            @tooltip-enter="onTooltipEnter"
            @tooltip-leave="onTooltipLeave"
            @open-detail="onTimeslotSelectEvent"
        />
        <DetailPanel
            :event="detailEvent"
            :visible="detailPanelVisible"
            :token="token"
            @close="detailPanelVisible = false"
            @pay="onOpenPayment"
            @edit="onEditDetailPanel"
            @cancel="onCancelDetailPanel"
        />
        <PaymentPopup
            :event="paymentEvent"
            :visible="paymentPopupVisible"
            @close="paymentPopupVisible = false"
            @validate="onPaymentValidate"
        />
        <CalendarToolBar
            @change-page="onChangePage"
            :loading="loading"
            :events="calc_eventList"
            @refresh="handledReloadCalendarTimeSlot"
        />

        <div class="ppv2-flex-1 ppv2-overflow-hidden ppv2-flex ppv2-flex-col">
            <!-- Grid View -->
            <div v-if="viewMode === 'grid'" class="d-flex fixed-max-height">
                <div class="horizontal-scroll">
                    <v-app class="vertical-scroll">
                        <v-overlay v-if="loading > 0" :value="true" absolute class="calendar-overlay">
                            <v-progress-circular
                                style="position: fixed; left: 50%"
                                indeterminate
                                size="64"
                                color="secondary"
                            ></v-progress-circular>
                        </v-overlay>
                        <v-sheet width="100%" :min-width="calc_calendarMinWidth" v-bind:class="{ calendarday: c_nbOfDay === 1 }">
                            <!-- Calendar- -->
                            <v-calendar
                                locale="fr"
                                ref="calendar"
                                type="category"
                                color="secondary"
                                category-show-all
                                v-model="c_dateFocus"
                                event-overlap-mode="column"
                                :columns="[]"
                                :first-time="c_firstTime"
                                :events="calc_event"
                                :categories="calc_categoriesName"
                                :interval-minutes="c_intervalMinutes"
                                :interval-count="calc_IntervalCount"
                                :interval-height="calc_IntervalHeight"
                                :category-days="c_nbOfDay"
                                @mousedown:event="onMouseDownEvent"
                                @mousedown:time-category="onMouseDownColumn"
                                @mousemove:time-category="onMouseMovColumn"
                                @mouseup:time-category="onMouseUpColumn"
                                @mousemove:time="onHoverInterval"
                                @mouseleave:time="() => (hoverTime = null)"
                            >
                                <!-- SLOT: category name -->
                                <template v-slot:category="data">
                                    <div
                                        :set="
                                            (color = c_selectedCategory === data.category && data.date === calc_selectedDateKey)
                                        "
                                    >
                                        <div
                                            v-if="JSON.parse(data.category).type === 'space'"
                                            class="v-calendar-category__category v-calendar-space"
                                        >
                                            <!-- <v-icon color="#b1dad6">mdi-layers</v-icon>-->
                                            <span>{{ JSON.parse(data.category).name }}</span>
                                        </div>
                                        <div v-else class="v-calendar-category__category v-calendar-staff">
                                            <v-icon color="#4b5b6b">mdi-account</v-icon>
                                            <span
                                                >{{ JSON.parse(data.category).first_name }}
                                                {{ JSON.parse(data.category).last_name }}</span
                                            >
                                        </div>
                                    </div>
                                </template>

                                <template v-slot:interval="event">
                                    <div
                                        style="width: 100%; height: 100%"
                                        v-bind:class="{
                                            hover_grey: calc_hoverCellKey && `${event.date} ${event.time}` === calc_hoverCellKey,
                                        }"
                                    >
                                        <div
                                            style="width: 100%; height: 100%; text-align: center; position: relative"
                                            v-bind:class="{
                                                'colored-case':
                                                    calc_selectedCellKey &&
                                                    `${event.date} ${event.time}` === calc_selectedCellKey,
                                                'force-color':
                                                    c_showModal &&
                                                    calc_selectedCellKey &&
                                                    `${event.date} ${event.time}` === calc_selectedCellKey &&
                                                    calc_categoriesName.length === 0,
                                                'cv3-out-hours': calc_isOutOfHours(event.time),
                                            }"
                                        >
                                            <span
                                                class="hover-actions"
                                                v-if="
                                                    calc_hoverCellKey &&
                                                    `${event.date} ${event.time}` === calc_hoverCellKey &&
                                                    !calc_isHoverBooked(event)
                                                "
                                            >
                                                <span class="pp-tooltip-wrapper">
                                                    <v-btn
                                                        icon
                                                        small
                                                        class="btn-add-hover"
                                                        @mousedown.stop="openV3Modal('reservation', event)"
                                                    >
                                                        <v-icon small>mdi-plus</v-icon>
                                                    </v-btn>
                                                    <div class="pp-tooltip-content">{{ $t('planning_v3.take_reservation') }}</div>
                                                </span>

                                                <span class="pp-tooltip-wrapper">
                                                    <v-btn
                                                        icon
                                                        small
                                                        class="btn-block-hover"
                                                        @mousedown.stop="openV3Modal('block', event)"
                                                    >
                                                        <v-icon small>mdi-block-helper</v-icon>
                                                    </v-btn>
                                                    <div class="pp-tooltip-content">{{ $t('planning_v3.block_slot') }}</div>
                                                </span>
                                            </span>

                                            <div
                                                v-if="
                                                    c_showModal &&
                                                    (modalMode === 'reservation' || modalMode === 'block') &&
                                                    (!c_selectedEvent || c_selectedEvent.config.draft || addNContributor) &&
                                                    calc_selectedCellKey &&
                                                    `${event.date} ${event.time}` === calc_selectedCellKey &&
                                                    (event.category ? event.category === c_selectedCategory : true)
                                                "
                                                :class="['cv3-ghost-slot', modalMode === 'block' ? 'cv3-ghost-slot--block' : '']"
                                            >
                                                <span class="cv3-ghost-slot-label">{{ calc_ghostLabel }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <!-- SLOT: day header -->
                                <template v-slot:day-label-header="{ date }">
                                    <div
                                        class="ppv2-text-black poppinsMedium uppercaseFirstLetter"
                                        style="font-size: clamp(12px, 0.729545vw, 16px)"
                                    >
                                        {{ calc_formatDateHeader(date) }}
                                    </div>
                                </template>

                                <!-- SLOT: timeslots -->
                                <template v-slot:event="{ event }">
                                    <CustomTimeslot
                                        :event="event"
                                        @open-payment="onOpenPayment"
                                        @hover-enter="onTimeslotHoverEnter"
                                        @hover-leave="onTimeslotHoverLeave"
                                        @hover-move="onTimeslotHoverMove"
                                        @select-event="onTimeslotSelectEvent"
                                    ></CustomTimeslot>
                                </template>

                                <!-- SLOT: current time line -->
                                <template v-slot:day-body="{ date, week }">
                                    <div
                                        class="v-current-time"
                                        :class="{ first: date === week[0].date }"
                                        :style="{ top: `${calc_currentTimePos}%`, display: calc_showCurrentTimeCursor }"
                                    ></div>
                                </template>
                            </v-calendar>
                        </v-sheet>
                    </v-app>
                </div>

                <!-- Modal -->
                <div
                    v-if="!c_modalMobile && c_showModal"
                    :class="{
                        'calendar-border calendar-modal': true,
                        'calendar-panel-detail': (modalMode === 'reservation' || modalMode === 'block') && !minimized,
                        'calendar-modal-edit-host': detailModalAction === 'edit' || Boolean(c_bookingEditTimeslot),
                        'minimized-modal': minimized,
                        'hide-scale': minimized,
                    }"
                >
                    <template v-if="!c_smartResa">
                        <CalendarModalAddV3
                            :minimized="minimized"
                            :compact-edit="Boolean(c_bookingEditTimeslot)"
                            v-if="
                                (!c_selectedEvent || c_selectedEvent.config.draft || addNContributor) &&
                                modalMode === 'reservation'
                            "
                            @close="closeCalendarModal"
                            @minimize="minimized = !minimized"
                            @refresh="handledReloadCalendarTimeSlot"
                            :preSelected="preSelected"
                        ></CalendarModalAddV3>
                        <CalendarModalBlockV3
                            :minimized="minimized"
                            v-if="(!c_selectedEvent || c_selectedEvent.config.draft || addNContributor) && modalMode === 'block'"
                            @close="c_showModal = false"
                            @minimize="minimized = !minimized"
                            @refresh="handledReloadCalendarTimeSlot"
                            :date="c_selectedTimePos"
                            :interval="c_intervalMinutes"
                        ></CalendarModalBlockV3>
                        <CalendarModalViewV3
                            v-else-if="c_selectedEvent"
                            :minimized="minimized"
                            :initial-action="detailModalAction"
                            @initial-action-done="detailModalAction = ''"
                            @close="c_showModal = false"
                            @minimize="minimized = !minimized"
                            @refresh="handledReloadCalendarTimeSlot"
                        ></CalendarModalViewV3>
                    </template>
                    <template v-else>
                        <CalendarModalSmartResa
                            v-on:choose="chooseAddTrigger"
                            :startEsta="this.c_firstTime"
                            :endEsta="this.c_lastTime"
                        ></CalendarModalSmartResa>
                    </template>
                </div>
            </div>

            <div v-else-if="viewMode === 'list'" class="ppv2-flex-1 ppv2-overflow-y-auto">
                <CalendarListing :events="calc_eventList" :nb-of-day="c_nbOfDay" @select-resa="onSelectResaFromList" />
                <!--@open-payment="onOpenPayment"-->
            </div>

            <!-- Drawer -->
            <v-navigation-drawer
                v-if="
                    c_showModal &&
                    !(detailModalAction === 'edit' || Boolean(c_bookingEditTimeslot)) &&
                    (c_modalMobile || (viewMode === 'list' && c_selectedEvent))
                "
                right
                absolute
                permanent
                v-model="c_showModal"
                :class="{
                    'calendar-border calendar-modal': true,
                    'calendar-modal-edit-host': detailModalAction === 'edit' || Boolean(c_bookingEditTimeslot),
                    'minimized-modal': minimized,
                }"
            >
                <v-app>
                    <template v-if="!c_smartResa">
                        <CalendarModalAddV3
                            :minimized="minimized"
                            :compact-edit="Boolean(c_bookingEditTimeslot)"
                            v-if="
                                (!c_selectedEvent || c_selectedEvent.config.draft || addNContributor) &&
                                modalMode === 'reservation'
                            "
                            @close="closeCalendarModal"
                            @minimize="minimized = !minimized"
                            @refresh="handledReloadCalendarTimeSlot"
                            :preSelected="preSelected"
                        ></CalendarModalAddV3>
                        <CalendarModalBlockV3
                            :minimized="minimized"
                            v-if="(!c_selectedEvent || c_selectedEvent.config.draft || addNContributor) && modalMode === 'block'"
                            @close="c_showModal = false"
                            @minimize="minimized = !minimized"
                            @refresh="handledReloadCalendarTimeSlot"
                            :date="c_selectedTimePos"
                            :interval="c_intervalMinutes"
                        ></CalendarModalBlockV3>
                        <CalendarModalViewV3
                            v-else-if="c_selectedEvent"
                            :minimized="minimized"
                            :initial-action="detailModalAction"
                            @initial-action-done="detailModalAction = ''"
                            @close="c_showModal = false"
                            @minimize="minimized = !minimized"
                            @refresh="handledReloadCalendarTimeSlot"
                        ></CalendarModalViewV3>
                    </template>
                    <template v-else>
                        <CalendarModalSmartResa></CalendarModalSmartResa>
                    </template>
                </v-app>
            </v-navigation-drawer>
        </div>
    </v-app>
</template>
<style scoped>
.calendar-modal-edit-host {
    position: fixed !important;
    top: 0 !important;
    right: auto !important;
    bottom: auto !important;
    left: 0 !important;
    z-index: 100001 !important;
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    height: 0 !important;
    overflow: visible !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.edit-reservation-loading-overlay {
    position: fixed;
    inset: 0;
    z-index: 100002;
    display: grid;
    place-items: center;
    background: rgba(2, 24, 50, 0.38);
}

.booking-item {
    border: 1px solid #d4d6d9;
    width: 100%;
    margin: 5px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    z-index: 10;
}

.cmd-info {
    min-width: 280px;
    max-width: 500px;
    padding: 0 10px;
    border-radius: 5px;
    font-size: clamp(12px, 0.729545vw, 16px);
    max-height: 200px;
    overflow-y: auto;
}

.rsv-client {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.cmd-info::-webkit-scrollbar {
    width: 4px;
    height: 2px;
    z-index: 1;
}

.cmd-info::-webkit-scrollbar-thumb {
    background-color: #7d2dbd;
    border-radius: 5px;
    opacity: 1;
}

.cmd-info::-webkit-scrollbar-track {
    background-color: #fff;
    cursor: pointer;
}

.cmd-info .bloc {
    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    padding: 4px;
    width: 100%;
    margin-bottom: 12px;
}

.bloc .b-info {
    /*flex: 33%;*/
    text-align: center;
}

.bloc .b-title {
    font-family: Poppins Regular;
    font-size: 16px;
    text-align: left;
}

.booking-item .user {
    width: 100%;
    height: 40px;
    align-items: center;
    line-height: 40px;
    overflow: hidden;
    color: var(--Navy, var(--Navy, #021832));
    font-family: Poppins Regular;
    font-size: 16px;
    position: relative;
    display: flex;
}

.user .details {
    display: flex;
    padding: 0px;
    height: 26px;
    border-radius: 4px;
    font-family: Poppins Regular;
    font-size: clamp(12px, 0.729545vw, 16px);
    margin: 0px 2px;
    position: relative;
    text-align: center;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    width: 100%;
}

.box {
    width: 100%;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;
    opacity: 1;
    /* for demo purpose  */
}

.box:hover {
    cursor: pointer;
}

.user .box {
    width: 100%;
    opacity: 1;
}

.stack-top {
    z-index: 9;
    margin: 0;
    /* for demo purpose  */
}

.price {
    color: #000;
    /* flex: 0 0 115px; */
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nb-ticket {
    color: #fff;
    background-color: #94a3b8;
    flex: 0 0 100px;
}

.percentage {
    color: #fff;
    background-color: #000;
    flex: 0 0 74px;
}

.booking-item:hover {
    background-color: #bcdee1;
    cursor: pointer;
}

.b-modal-header {
    width: 100%;
    color: #021832;
    font-family: Poppins Regular;
    font-size: 18px;
    padding: 5px 25px 5px 0;
    margin-bottom: 18px;
    position: relative;
    border-bottom: 1px solid #f1f5f9;
}

.b-modal-header .close-btn {
    border-radius: 50%;
    cursor: pointer;
    padding: 8px 13px;
}

.b-add-btn {
    background-color: #021832;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    border: none;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
}

.b-add-btn:hover {
    background-color: #021832 !important;
    opacity: 0.7;
}

#page-container.page-header-fixed #main-container {
    padding-bottom: 5px !important;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(4, 12, 21, 0.7);
    /* semi-transparent background */
    display: none;
    justify-content: right;
    align-items: right;
    z-index: 10000;
    padding: 10px;
    border-radius: 5px;
}

.overlay-content {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    gap: 10px;
    justify-content: right;
}

.disabled-icon {
    color: grey;
    /* Adjust the color for disabled state */
}

.user:hover .overlay {
    display: flex;
    /* Show overlay on hover */
}

.is-quote {
    background-color: yellow;
}

.acceptation-error {
    color: red;
    border-radius: 7px;
    border: 2px solid red;
    font-size: 11px;
    background: white;
    display: flex;
    position: absolute;
    text-align: center;
    justify-content: center;
    left: 6px;
    height: 35px;
    top: 3px;
    align-items: center;
    padding: 6px;
}

@media screen and (max-width: 600px) {
    .popup {
        position: fixed;
        background: #fff;
        padding: 10px 0;
        z-index: 99999;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        min-height: 200px;
        min-width: 290px;
        max-width: 500px;
        border-radius: 12px;
        border: 1px solid var(--Grey, #94a3b8);
        width: 100%;
    }
}
</style>
<script>
import SegmentedControl from '../Shared/SegmentedControl.vue'
import ApiManager from './_core/ApiManager'
import InitManager from './_core/InitManager'
import TimeSlotManager from './_core/TimeSlotManager'
import { sync, get } from 'vuex-pathify'
import qs from 'qs'
import moment from 'moment'
import ActivityManager from './_core/ActivityManager'
import introJs from 'intro.js'
import { computeOutOfHoursExtremes } from '../../utils/outOfHours'
const urlParams = new URLSearchParams(window.location.search)
const paramDate = moment(urlParams.get('str_date'), 'YYYY-MM-DD')
const paramSpace = urlParams.get('space_id')

export default {
    name: 'calendar-custom',

    components: {
        SegmentedControl,
        CalendarToolBar: () => import('./ToolBar/ToolBarV3.vue'),
        CustomTimeslot: () => import('./Timeslot/Timeslot.vue'),
        CalendarListing: () => import('./Listing/PlanningListing.vue'),
        CalendarModalAddV3: () => import('./Modal/ModalAddV3.vue'),
        CalendarModalBlockV3: () => import('./Modal/ModalBlockV3.vue'),
        CalendarModalViewV3: () => import('./Modal/ModalViewV3.vue'),
        CalendarModalSmartResa: () => import('./Modal/ModalSmartResa.vue'),
        OrderDetailsTooltip: () => import('./OrderDetailsTooltip.vue'),
        HoverTooltip: () => import('./Popup/HoverTooltip.vue'),
        DetailPanel: () => import('./Popup/DetailPanel.vue'),
        PaymentPopup: () => import('./Popup/PaymentPopup.vue'),
    },
    props: {
        token: { type: String, default: '' },
    },

    data: () => ({
        currentWindow: {
            height: 0,
            width: 0,
        },
        hoverTime: 0,
        hoverCategory: null,
        loading: 0,
        mousePress: false,
        lockMove: true,
        disableHover: true,
        disableHoverDate: Date.now(),
        lastStaffs: null,
        lastSpaces: null,
        protectCall: false,
        protectCall2: Date.now(),
        chooseAdd: null,
        nowTime: moment(),
        nowTimeInterval: null,
        lastDateFocus: null,
        phantom: false,
        minimized: false,
        modalMode: 'reservation', // 'reservation' or 'block'
        collapseState: {},
        collapseCounts: { morning: 0, evening: 0 },
        visibleBounds: null,
        collapseObserver: null,
        collapseObserverSetup: false,
        lastSchedule: null,
        lastAutoScrollDate: null,
        autoScrolledToNow: false,
        diffTime: 0,
        selectAll: false,
        moved: false,
        refreshModal: false,
        ordersData: [],
        selectedBooking: null,
        selectedContext: null,
        popupStyle: {
            top: '0',
            left: '0',
        },
        preSelected: {
            status: false,
            prestationID: null,
            bookingIDs: null,
            timeSlotID: null,
        },
        addNContributor: false,
        getTotalCMDDetails: { currentPrice: 0, totalPrice: 0, currentTicketsNbr: 0, totalTicketsNbr: 0 },
        acceptationLoading: {
            accept: false,
            decline: false,
        },
        showOverlay: false,
        showAcceptDeclineOptions: true,
        acceptationError: null,
        hoverEvent: null,
        hoverRect: null,
        hoverVisible: false,
        hoverTimeout: null,
        hoverMouseOnCard: false,
        detailEvent: null,
        detailPanelVisible: false,
        detailModalAction: '',
        paymentEvent: null,
        paymentPopupVisible: false,
    }),

    created() {
        // Replace 'paramName' with the actual parameter name
        // Replace 'paramName' with the actual parameter name

        this.c_calendar = InitManager.createInitialCalendarState()
        this.c_dateFocus = paramDate.isValid()
            ? paramDate.format('YYYY-MM-DD')
            : //    : localStorage.getItem('date-focus') || moment(new Date('2024-12-12')).format('YYYY-MM-DD')
              moment(Date.now()).format('YYYY-MM-DD')
        // == Auto resize == //
        globalThis.window.addEventListener('resize', this.handleResize)
        globalThis.window.addEventListener('mouseup', this.handleMouseUp)
        this.handleResize()
        this._loadCollapseState()

        // == Params == //
        this.c_query = !window.location.search ? {} : qs.parse(window.location.search?.replace('?', ''))
        if (this.c_query.date) this.c_dateFocus = moment(parseInt(this.c_query.date) * 1000).format('YYYY-MM-DD')
        if (this.c_query.modaladd || this.c_query.rebooking) this.c_showModal = true

        this.nowTimeInterval = setInterval(() => {
            this.nowTime = moment()
        }, 1000 * 60)
    },

    async mounted() {
        const srcElem = globalThis.document.getElementsByClassName('horizontal-scroll')[0]
        const destElem = globalThis.document.getElementsByClassName('v-calendar-daily__intervals-body')[0]
        const destHeader = globalThis.document.getElementsByClassName('v-calendar-daily__intervals-head')[0]
        if (srcElem && destElem && destHeader) {
            // Batch the sync writes into a single animation frame so a burst of
            // scroll events triggers at most one layout write per frame instead of
            // one synchronous reflow per event (identical final position, no jank).
            let scrollRaf = null
            srcElem.onscroll = () => {
                if (scrollRaf !== null) return
                scrollRaf = globalThis.requestAnimationFrame(() => {
                    scrollRaf = null
                    const left = `${srcElem.scrollLeft - 1}px`
                    destElem.style.left = left
                    destHeader.style.left = left
                })
            }
        }

        // == Data Loading == //
        this.loading += 3
        try {
            const [staffs, spaces, presetData] = await Promise.all([
                ApiManager.getStaffs(),
                ApiManager.getSpaces(),
                ApiManager.getPresets(),
            ])

            this.c_staffs = staffs
            this.c_spaces = spaces
            this.c_presets = presetData.items || []
            this.c_selectedPresetName = presetData.activePresetName || null

            // Apply preset or default selection
            let presetApplied = false
            if (this.c_selectedPresetName) {
                // Check if applyPreset method exists, if not use the logic directly
                const target = this.c_presets.find((x) => x.name === this.c_selectedPresetName)
                if (target) {
                    await this.applyPreset()
                    presetApplied = true
                }
            }

            if (!presetApplied || (this.c_selectedStaffs.length === 0 && this.c_selectedSpaces.length === 0)) {
                // Parité V2 : colonnes = ESPACES par défaut (les praticiens restent
                // disponibles dans le menu Filtres). Repli sur les praticiens uniquement
                // si le centre n'a aucun espace configuré.
                if (this.c_spaces.length > 0) {
                    this.c_selectedSpaces = [...this.c_spaces]
                    this.c_selectedStaffs = []
                } else {
                    this.c_selectedStaffs = [...this.c_staffs]
                    this.c_selectedSpaces = []
                }
            }

            // Set default view mode to grid
            this.viewMode = 'grid'

            if (this.c_query.date && this.c_query.timeslot) {
                await this.loadTargetedTimeslot()
            }
        } finally {
            this.loading = Math.max(0, this.loading - 3)
        }
    },

    beforeDestroy() {
        globalThis.window.removeEventListener('resize', this.handleResize)
        globalThis.window.removeEventListener('mouseup', this.handleMouseUp)
        if (this.collapseObserver) {
            this.collapseObserver.disconnect()
            this.collapseObserver = null
        }
    },

    destroyed() {
        if (this.nowTimeInterval) clearInterval(this.nowTimeInterval)
    },

    updated() {
        // Vuetify reconstruit la gouttière des heures à chaque changement de plage,
        // de trame, de colonnes, de vue... : la MutationObserver et ce appel ré-injectent
        // les flèches de repli dès qu'elles ont été effacées par ce rebuild.
        this._ensureCollapseObserver()
        if (this.visibleBounds) this._renderCollapseArrows()
    },

    watch: {
        async c_selectedPresetName(val, oldVal) {
            // Skip on initial mount
            if (oldVal === undefined) return

            if (val === null) this.resetPreset()
            else await this.applyPreset()
        },
        async c_forceLoad(val, old) {
            if (old === undefined) return
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },
        async c_dateFocus(val, old) {
            if (old === undefined) return
            localStorage.setItem('date-focus', val)
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            this.hoverCategory = null
            // cancel the merge when change date
            // We can merge only the orders present in the same day
            this.c_merge_status = false
            this.c_merge_events = []
        },
        async c_nbOfDay(val, old) {
            if (old === undefined) return
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },
        async c_selectedStaffs(val) {
            if (this.lastStaffs === null && val && val.length == 0) return

            if (JSON.stringify(val) != this.lastStaffs) {
                this.lastStaffs = JSON.stringify(val)
                this.loading += 1
                await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            }
        },
        async c_selectedSpaces(val) {
            if (this.lastSpaces === null && val && val.length == 0) return

            if (JSON.stringify(val) != this.lastSpaces) {
                this.lastSpaces = JSON.stringify(val)
                this.loading += 1
                await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
            }
        },
        calc_columnNbr(val) {
            const srcElems = globalThis.document.getElementsByClassName('v-calendar-daily__day')
            for (const index in srcElems) {
                if (isNaN(index)) continue

                if (index % (this.c_selectedStaffs.length + this.c_selectedSpaces.length) == val) {
                    srcElems[index].classList.add('selectedCategory')
                } else srcElems[index].classList.remove('selectedCategory')
            }
        },
        calc_columnNbrHover(val) {
            const srcElems = globalThis.document.getElementsByClassName('v-calendar-daily__day')
            for (const index in srcElems) {
                if (isNaN(index)) continue

                if (this.c_selectedStaffs.length + this.c_selectedSpaces.length === 0) {
                    srcElems[index].classList.remove('selectedCategoryHover')
                } else if (index % (this.c_selectedStaffs.length + this.c_selectedSpaces.length) !== val) {
                    srcElems[index].classList.add('selectedCategoryHover')
                } else srcElems[index].classList.remove('selectedCategoryHover')
            }
        },

        diffTime() {
            if (this.selectAll) this.DragAllRelated()
            this.diffTime = 0
        },
        selectedBooking(val) {
            this.setTotalCMDDetails()
        },
    },

    computed: {
        c_calendar: sync('calendar'),
        ...sync('calendar@data', {
            c_staffs: 'staffs',
            c_spaces: 'spaces',
            c_events: 'events',
            c_hideEvents: 'hideEvents',
            c_hideStaffs: 'hideStaffs',
            c_counterConsecColumn: 'counter',
            c_presets: 'presets',
        }),
        ...sync('calendar@params', {
            c_dateFocus: 'dateFocus',
            c_showModal: 'showModal',
            c_showModalOrderList: 'showModalOrderList',
            c_miniToolBar: 'miniToolBar',
            c_smartResa: 'smartResa',
            c_query: 'query',
            c_reopentTimeslot: 'openTimeslot',
            c_lastTime: 'lastTime',
            c_firstTime: 'firstTime',
            c_nbOfDay: 'nbOfDay',
            viewMode: 'viewMode',
            c_slideValueX: 'intervalXLevel',
            c_slideValueY: 'intervalYLevel',
            c_timeIntervalMinutes: 'intervalMinutes',
        }),
        ...get('calendar@params', {
            c_intervalMinutes: 'intervalMinutes',
            c_intervalYLevel: 'intervalYLevel',
            c_intervalXLevel: 'intervalXLevel',
            c_modalMobile: 'modalMobile',
            newLogin: 'newLogin',
        }),
        ...sync('calendar@selected', {
            c_selectedStaffs: 'staffs',
            c_selectedSpaces: 'spaces',
            c_forceLoad: 'load',
            c_search: 'search',
            c_selectedPresetName: 'preset',
            c_editEvents: 'editEvents',
        }),
        ...sync('calendar@selected', {
            c_selectedCategory: 'category',
            c_selectedEvent: 'event',
            c_selectedTimePos: 'mouseTime',
            c_bookingEditTimeslot: 'bookingEditTimeslot',
        }),
        ...sync('calendar@move', {
            c_move_id: 'move_id',
            c_move_start: 'move_start',
            c_move_end: 'move_end',
            c_move_event: 'move_event',
            c_move_drag: 'move_drag',
            c_duration: 'move_duration',
            c_move_date: 'move_date',
        }),
        ...sync('calendar@merge', {
            c_merge_status: 'status',
            c_merge_events: 'events',
        }),
        // Hover / selection cell keys computed once per reactive change instead of
        // being re-evaluated per interval cell inside the template class bindings.
        // Values are identical to the inline timeGetter/timeGetterAround calls they
        // replace; only the number of evaluations changes (O(1) vs O(cells)).
        calc_hoverCellKey() {
            return this.hoverTime ? this.timeGetterAround(this.hoverTime) : null
        },
        calc_selectedCellKey() {
            return this.c_selectedTimePos ? this.timeGetter(this.c_selectedTimePos) : null
        },
        calc_selectedDateKey() {
            return this.timeGetter(this.c_selectedTimePos, true)
        },
        calc_ghostLabel() {
            if (!this.c_selectedTimePos) return ''
            const start = moment(this.c_selectedTimePos).format('HH:mm')
            const end = moment(this.c_selectedTimePos).add(this.c_intervalMinutes, 'minutes').format('HH:mm')
            const label = this.modalMode === 'block' ? 'Nouveau blocage' : 'Nouvelle réservation'
            return `${label} · ${start} - ${end}`
        },

        // Catégories dont le temps survolé est couvert par une réservation. La granularité est
        // l'INSTANT survolé, pas la cellule : une cellule 10:00-11:00 qui ne porte qu'une résa
        // 10:15-10:30 reste libre à 10:35, donc les boutons de survol y réapparaissent.
        // Nécessaire car le slot `interval` de Vuetify ne connaît pas les events (dessinés dans
        // une couche absolue au-dessus des cellules).
        // Basé sur c_events (et non calc_event) : config.display ne garde qu'un event par créneau
        // multi-réservations, et une résa masquée par la recherche occupe quand même le temps.
        // Recalculé une fois par mousemove (O(events)) et non une fois par cellule.
        calc_hoverBookedCategories() {
            const cats = new Set()
            if (!this.hoverTime) return cats
            const t = moment(this.hoverTime).valueOf()

            this.c_events.forEach((x) => {
                if (!x.data || !x.data.bookingId) return // ni draft, ni blocage/indispo
                if (t < x.start || t >= x.end) return // borne de fin exclusive
                cats.add(x.category)
                cats.add('*') // aucune colonne sélectionnée => Vuetify passe category=null
            })

            return cats
        },

        calc_event() {
            return !this.c_search
                ? this.c_events.filter((x) => {
                      return x.config.display ?? true
                  })
                : this.c_events.filter((x) => {
                      return (
                          x.config.block ||
                          ((x.config.display ?? true) &&
                              x.data &&
                              x.data.client &&
                              x.data.client.toLowerCase().includes(this.c_search.toLowerCase())) ||
                          (x.data &&
                              x.data.prestation &&
                              x.data.prestation.name.toLowerCase().includes(this.c_search.toLowerCase()))
                      )
                  })
        },

        // Réservations pour la vue LISTE et le compteur du toolbar : tous les events de
        // booking, SANS le filtre config.display qui ne garde qu'un event par créneau pour
        // la grille — sinon les créneaux multi-réservations sont sous-comptés (B6).
        // Le filtre de recherche reste appliqué.
        calc_eventList() {
            const base = this.c_events.filter((x) => x.data && x.data.bookingId)
            if (!this.c_search) return base
            const q = this.c_search.toLowerCase()
            return base.filter(
                (x) =>
                    (x.data.client && x.data.client.toLowerCase().includes(q)) ||
                    (x.data.prestation && x.data.prestation.name && x.data.prestation.name.toLowerCase().includes(q))
            )
        },

        calc_columnNbr() {
            if (!this.lockMove || this.disableHover || !this.c_showModal) return -1
            if (this.c_selectedCategory) {
                const index = this.calc_categoriesName.findIndex((x) => x == this.c_selectedCategory)
                return index
            }
            return -1
        },
        calc_columnNbrHover() {
            if (!this.hoverCategory) return -1
            const index = this.calc_categoriesName.findIndex((x) => x == this.hoverCategory)
            return index
        },

        // Used with intervalXLevel to expend/compact calendar width
        calc_calendarMinWidth() {
            let counter = 0
            for (const key in this.c_counterConsecColumn) {
                counter += this.c_counterConsecColumn[key] + 1
            }

            //  return `${Math.floor(counter * 50 + Math.floor((counter * 50 * this.c_intervalXLevel) / 3))}px`
            return `${Math.floor(100 + Math.floor(100 * this.c_intervalXLevel))}%`
        },

        // Used with c_intervalYLevel to expend/compact height cell
        calc_IntervalHeight() {
            return `${
                (this.currentWindow.height - 280) / this.calc_IntervalCount +
                5 * ((this.c_intervalYLevel > 5 ? this.c_intervalYLevel * 4 : this.c_intervalYLevel) * 2)
            }px`
        },

        // Compute minutes between interval [first time <-> last time]
        calc_calendarDayMinutes() {
            const start = moment(this.c_firstTime, 'hh:mm')
            const end = moment(this.c_lastTime, 'hh:mm')
            return moment.duration(end.diff(start)).asMinutes()
        },

        // Compute the nb of needed interval
        calc_IntervalCount() {
            return this.calc_calendarDayMinutes / this.c_intervalMinutes + 1
        },

        // Generate all calendar column name's
        calc_categoriesName() {
            return this.c_selectedStaffs
                .filter(
                    (x) =>
                        !this.c_hideStaffs.find((y) => y.id === x.id && y.count === 0 && !x.tmp) ||
                        this.c_events.find((e) => !e.config.block && e.category === x.stringify)
                )
                .map((x) => x.stringify)
                .concat(this.c_selectedSpaces.map((x) => x.stringify))
        },

        // Used to display current time curssor
        calc_currentTimePos() {
            const start = moment(this.c_firstTime, 'hh:mm')
            const now = this.nowTime
            const tt = this.calc_calendarDayMinutes
            return (moment.duration(now.diff(start)).asMinutes() * 100) / tt
        },

        // Is today ?
        calc_showCurrentTimeCursor() {
            return this.c_dateFocus === moment().format('YYYY-MM-DD') ? 'relative' : 'none'
        },
    },

    methods: {
        async applyPresetAfterLoad() {
            // Attendre un peu pour être sûr que les données sont chargées
            await new Promise((resolve) => setTimeout(resolve, 100))

            const preset = this.c_presets.find((p) => p.name === this.c_selectedPresetName)
            if (!preset) return false

            // Appliquer le preset
            await this.$store.dispatch('applyPreset', {
                preset: preset,
                updateSelections: true,
            })

            // Forcer un rechargement
            await this.reloadCalendarTimeSlot()
            return true
        },
        async applyPresetFromName(presetName) {
            const preset = this.c_presets.find((p) => p.name === presetName)
            if (!preset) return

            // Appliquer via l'action Vuex (action racine, le module calendar n'est pas namespacé)
            await this.$store.dispatch('applyPreset', {
                preset: preset,
                updateSelections: true,
            })

            // Forcer le rechargement
            await this.reloadCalendarTimeSlot()
        },
        closeModal() {
            this.c_showModal = false
            this.c_move_event = []
        },
        onOpenPayment(event) {
            this.paymentEvent = event
            this.detailPanelVisible = false
            this.paymentPopupVisible = true
        },
        onPaymentValidate(payload) {
            // TODO: appeler l'API d'encaissement avec payload.payments
            // payload = { event, payments: [{ method: 'cb', amount: 20 }, ...] }
            console.log('Payment validated:', payload)
            this.paymentPopupVisible = false
            this.$toast &&
                this.$toast.success(this.$t('planning_v3.payment.validate'), {
                    position: 'top-right',
                    timeout: 3000,
                })
        },
        canAddNewResravation(context) {
            let res
            switch (this.getPrestationTypeSlug(context.event.data.prestation)) {
                case 'vr':
                    res = false
                    break
                case 'events':
                    res = context.event.data.info.nb_contributor < context.event.data.prestation.type
                    break
                case 'simpleticket':
                    res = context.event.data.info.nb_contributor < context.event.data.info.space.capacity
                    break
                case 'paintball':
                    res =
                        context.event.data.info.nb_contributor <
                            Math.min(
                                context.event.data.info.space.capacity,
                                context.event.data.prestation.max_contributors ?? 0
                            ) &&
                        (context.event.data.info.enableMixing ?? true)
                default:
                    res =
                        context.event.data.info.nb_contributor <
                        Math.min(context.event.data.info.space.capacity, context.event.data.prestation.max_contributors ?? 0)
                    break
            }
            return res
            // if (this.getPrestationTypeSlug(context.event.data.prestation) == 'events')
            //     return context.event.data.info.nb_contributor < context.event.data.prestation.type
            // else if (typeof context.event.data.info.enableMixing === 'undefined' || context.event.data.info.enableMixing === null)
            //     return (
            //         context.event.data.info.nb_contributor <
            //         Math.min(context.event.data.info.space.capacity, context.event.data.prestation.max_contributors ?? 0)
            //     )
            // else
            //     return (
            //         context.event.data.info.nb_contributor <
            //             Math.min(context.event.data.info.space.capacity, context.event.data.prestation.max_contributors ?? 0) &&
            //         context.event.data.info.enableMixing
            //     )
        },
        addNewContributor(context) {
            // console.log('contextcontextcontext', context)

            this.preSelected.prestationID = context.event.data.prestation.id
            this.preSelected.status = true
            this.preSelected.bookingIDs = context.event.bookings.map((x) => x.id)
            this.preSelected.timeSlotID = context.event.bookings[0].pivot.id_time_slot
            this.addNContributor = true
            this.c_showModal = true
            this.c_smartResa = false
            this.detailPanelVisible = false
        },

        updateInfo() {
            this.c_move_event = []
            this.c_move_staff = {}
            this.changeSelectAll(false)
            this.reloadCalendarTimeSlot()
        },
        refreshAutoSizeColumn() {
            // headers
            {
                const res = document.querySelector('.v-calendar-daily_head-day .v-calendar-category__columns')
                if (!res) return

                res.children.forEach((element, index) => {
                    const target = this.calc_categoriesName[index]
                    if (!target) return

                    const flex = this.c_counterConsecColumn[target]
                    if (!flex) return

                    //   element.setAttribute('style', `flex: ${flex < 1 ? 1 : flex} !important`)
                })
            }

            // body
            {
                const res = document.querySelector('.v-calendar-daily__day-container')
                if (!res) return

                res.children.forEach((element, index) => {
                    if (index === 0) return

                    const target = this.calc_categoriesName[index - 1]
                    if (!target) return

                    const flex = this.c_counterConsecColumn[target]
                    if (!flex) return

                    // element.setAttribute('style', `flex: ${flex < 1 ? 1 : flex} !important`)
                })
            }
        },

        timeGetter(date, onlyDate = false) {
            return moment(date).format(onlyDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')
        },

        getPrestationTypeSlug(prestat) {
            return prestat.subCategory.slug.toLowerCase()
        },

        chooseAddTrigger(params) {
            this.chooseAdd = params
            this.c_selectedEvent = null
            this.c_smartResa = false
            this.c_showModal = true
        },

        timeGetterAround(date) {
            const obj = moment(date)
            return obj.add(-date.minutes() % this.c_intervalMinutes, 'minutes').format('YYYY-MM-DD HH:mm')
        },

        // L'instant survolé est-il déjà réservé dans cette colonne ?
        calc_isHoverBooked({ category }) {
            return this.calc_hoverBookedCategories.has(category ?? '*')
        },

        calc_formatDateHeader(date) {
            return moment(date).locale(this.$i18n.locale).format('dddd D MMMM')
        },

        isTmp(cat) {
            if (cat.type === 'staff') {
                return this.c_selectedStaffs.find((x) => x.id === cat.id && x.tmp) != null
            } else {
                return this.c_selectedSpaces.find((x) => x.id === cat.id && x.tmp) != null
            }
        },

        async handledReloadCalendarTimeSlot() {
            this.preSelected.status = false
            this.addNContributor = false
            this.loading += 1
            await this.reloadCalendarTimeSlot().finally(() => (this.loading -= 1))
        },

        handleResize() {
            this.currentWindow.height = globalThis.window.innerHeight
            this.currentWindow.width = globalThis.window.innerWidth
            if (this.currentWindow.width < 958 && !this.c_miniToolBar) this.c_miniToolBar = true
            if (this.currentWindow.width >= 958 && this.c_miniToolBar) this.c_miniToolBar = false
        },

        handleMouseUp() {
            this.lockMove = true
        },
        changeSelectAll(value) {
            this.selectAll = value
            value
                ? this.c_events.forEach((z) => {
                      if (z.id == this.c_selectedEvent.id) z.config.movable = true
                  })
                : this.handledReloadCalendarTimeSlot()
        },
        // == Events == //
        async onChangePage(next) {
            if (next) this.$refs.calendar.next()
            else this.$refs.calendar.prev()
        },
        async onChangePhantom(dataphantom) {
            this.phantom = true
            this.reloadCalendarTimeSlot()
        },

        onHoverInterval(context) {
            this.hoverTime = moment(`${context.date} ${context.time}:00`)
        },

        // Click on timeslot
        onMouseDownEvent(context, event) {
            const evt = context.event
            if (!this.isPanelableEvent(evt)) return
            this.detailEvent = evt
            this.detailPanelVisible = true
            this.hoverVisible = false
            this.hoverEvent = null
        },
        // Vue LISTE : ouvrir le détail d'une réservation depuis le bouton "..." de la liste.
        onSelectResaFromList(payload) {
            const event = payload && payload.event
            if (!event) return
            this.onMouseDownAfterChoosingEvent({ event })
        },
        handleChoosingBooking(booking) {
            let selectedEv = this.c_events.find((x) => x.data.bookingId == booking.id)
            this.selectedContext.event = selectedEv
            this.detailPanelVisible = false
            this.onMouseDownAfterChoosingEvent(this.selectedContext)
        },
        onMouseDownAfterChoosingEvent(context) {
            if (!context.event.config.draft && this.c_events.find((x) => x.config.draft)) return
            if (context.event.category && !context.event.config.draft) {
                const wanted = JSON.parse(context.event.category)
                if (this.c_selectedSpaces.findIndex((y) => y.id == wanted.id) == -1) {
                    this.c_selectedSpaces.push(this.c_spaces.find((y) => y.id == wanted.id))
                }
                const target =
                    this.c_selectedSpaces.find((y) => y.id == wanted.id) || this.c_selectedStaffs.find((y) => y.id == wanted.id)

                if (target && target.tmp) target.tmp = false
            }
            this.c_showModal = true

            this.c_selectedEvent = context.event
            this.disableHover = true
            // Secure time
            this.disableHoverDate = Date.now() + 500

            // Merge orders
            if (this.c_merge_status) {
                const check = this.c_merge_events.find((x) => x.order_id == context.event.data.order_id)
                // Check if the item not already added to the merege list and doesn't closed (status = 7 in the DB)
                // Please not in front-end we are using the value 6 for closed CMD.
                if (!check && context.event.data.status != 6) {
                    let duplicates = {}
                    let relatedItems = Object.create(
                        this.c_events
                            .filter((x) => {
                                return x.data.order_id == context.event.data.order_id
                            })
                            .filter((item) => {
                                if (!duplicates[item.id]) {
                                    duplicates[item.id] = true
                                    return true
                                }
                                return false
                            })
                    )
                    relatedItems.sort((x, y) => x.start - y.start)
                    this.c_merge_events[1] = {
                        order_id: context.event.data.order_id,
                        booking_id: context.event.data.bookingId,
                        name: context.event.data.prestation.name,
                        timeslot_id: context.event.data.id,
                        client: context.event.data.client,
                        relatedItems: relatedItems,
                    }
                }
            }
        },

        // Hover handlers
        onTimeslotHoverEnter(ctx) {
            this.hoverMouseOnCard = true
            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout)
                this.hoverTimeout = null
            }
            this.hoverEvent = ctx.event
            this.hoverRect = {
                top: ctx.rect.top,
                bottom: ctx.rect.bottom,
                left: ctx.rect.left,
                right: ctx.rect.right,
                width: ctx.rect.width,
                height: ctx.rect.height,
            }
            if (typeof ctx.clientY === 'number') {
                this.hoverRect.top = ctx.clientY
            }
            this.hoverVisible = true
        },
        onTimeslotHoverMove(ctx) {
            if (this.hoverRect && this.hoverVisible && typeof ctx.clientY === 'number') {
                this.hoverRect.top = ctx.clientY
            }
        },
        onTimeslotHoverLeave() {
            this.hoverMouseOnCard = false
            this.startHoverClose()
        },
        onTooltipEnter() {
            this.hoverMouseOnCard = true
            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout)
                this.hoverTimeout = null
            }
        },
        onTooltipLeave() {
            this.hoverMouseOnCard = false
            this.startHoverClose()
        },
        startHoverClose() {
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout)
            this.hoverTimeout = setTimeout(() => {
                if (!this.hoverMouseOnCard) {
                    this.hoverVisible = false
                    this.hoverEvent = null
                }
            }, 200)
        },
        onTimeslotSelectEvent(event) {
            if (!this.isPanelableEvent(event)) return
            this.hoverVisible = false
            this.hoverEvent = null
            this.detailEvent = event
            this.detailPanelVisible = true
        },
        onEditDetailPanel(event) {
            if (!event) return
            this.detailPanelVisible = false
            this.detailModalAction = 'edit'
            this.onMouseDownAfterChoosingEvent({ event })
        },
        closeCalendarModal() {
            this.c_showModal = false
            this.c_bookingEditTimeslot = null
            this.detailModalAction = ''
        },
        onCancelDetailPanel(event) {
            if (!event) return
            this.detailPanelVisible = false
            this.detailModalAction = 'cancel'
            this.onMouseDownAfterChoosingEvent({ event })
        },
        // Un créneau vide (libre, sans réservation) ne doit PAS ouvrir le DetailPanel :
        // seul un bloc ou une réservation réelle est "affichable".
        isPanelableEvent(evt) {
            if (!evt) return false
            if (evt.config && evt.config.block) return true
            if (evt.bookings && evt.bookings.length) return true
            return !!(evt.data && evt.data.bookingId)
        },

        // Click on category
        onMouseDownColumn(context) {
            this.addNContributor = false
            this.preSelected.status = false
            if (this.detailPanelVisible) return
            if (
                this.c_selectedEvent &&
                this.c_selectedEvent.config.block &&
                this.c_selectedEvent.data &&
                this.c_selectedEvent.data.priority !== 3 &&
                !this.c_selectedEvent.data.lunch
            ) {
                this.c_selectedEvent = null
                this.c_showModal = false
                return
            }
            this.selectedBooking = null
            this.c_selectedCategory = context.category
            // this.c_showModal = true
            this.c_smartResa = false
            this.lockMove = false
            if (this.disableHoverDate < Date.now()) {
                this.disableHover = false
                this.c_selectedEvent = null
            }

            let cursorStart = moment(`${context.date} ${context.time}:00`)
            const remainder = -(cursorStart.minute() % this.c_intervalMinutes)
            cursorStart = cursorStart.add(remainder, 'minutes').valueOf()

            this.c_selectedTimePos = cursorStart
        },
        openV3Modal(mode, context) {
            this.modalMode = mode
            this.onMouseDownColumn(context)
            this.c_showModal = true
        },
        getPercentage(current, total) {
            if (total == 0) return 100
            let per = (current / total) * 100
            return per.toFixed(2)
        },
        onMouseMovColumn(context) {
            if (this.c_selectedEvent?.config.movable && this.c_move_drag) {
                const eventDate = new Date(this.c_selectedEvent.start)
                const mouseTime = new Date(eventDate.toDateString() + ' ' + context.time).getTime()
                let diff = 0
                if (mouseTime - this.c_selectedEvent.start >= 300000) {
                    this.moveReal(context, this.c_selectedEvent.start, mouseTime)
                    let allEvent = this.c_events.filter(
                        (ev) =>
                            ev.data.order_id == this.c_selectedEvent.data.order_id &&
                            ev.id != this.c_selectedEvent.id &&
                            ev.start > this.c_selectedEvent.start
                    )
                    // console.log('allEvent',allEvent)
                    allEvent.length > 0
                    {
                        let previous = allEvent[0]
                        let changed = false
                        if (this.c_selectedEvent.end >= allEvent[0].start) {
                            this.moved = true

                            allEvent.forEach((e, index) => {
                                if (allEvent[index].id != previous.id) {
                                    previous = allEvent[index - 1]
                                    changed = true
                                }
                                const diff = e.end - e.start
                                changed && e.id != allEvent[0].id
                                    ? (e.start = previous.end)
                                    : (e.start = this.c_selectedEvent.end)
                                e.end = e.start + diff
                            })
                        } else {
                            if (this.moved)
                                allEvent.forEach((e, index) => {
                                    if (allEvent[index].id != previous.id) {
                                        previous = allEvent[index - 1]
                                        changed = true
                                    }
                                    const diff = e.end - e.start
                                    changed && e.id != allEvent[0].id
                                        ? (e.start = previous.end)
                                        : (e.start = this.c_selectedEvent.end)
                                    e.end = e.start + diff
                                })
                        }
                    }
                }
            } else {
                this.hoverCategory = context.category
                if (this.lockMove || !this.c_selectedEvent || !this.c_selectedEvent.config.movable) return

                let collision = null
                let leave = false
                const newDate = moment(`${context.date} ${context.time}:00`).add(-10, 'minutes')
                newDate.add(-newDate.minutes() % 5, 'minutes')
                let newStart = newDate.valueOf()
                let newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)

                const parent = this.c_selectedEvent.parent ? this.c_selectedEvent.parent : this.c_selectedEvent
                if (
                    this.c_selectedEvent.config.draft &&
                    !this.c_selectedEvent.isIndispo &&
                    context.category != this.c_selectedEvent.category &&
                    this.c_nbOfDay === 1
                ) {
                    const contextCat = JSON.parse(context.category)
                    const eventCat = JSON.parse(this.c_selectedEvent.category)
                    if (contextCat.type != eventCat.type) return

                    if (!parent.list.find((x) => x.category === context.category)) {
                        if (contextCat.type === 'staff') {
                            parent.ref_presta.selectedPracticienne = parent.ref_presta.selectedPracticienne.filter(
                                (x) => x.id !== eventCat.id
                            )
                            parent.ref_presta.selectedPracticienne.push(contextCat)
                        } else {
                            parent.ref_presta.selectedSpace = contextCat
                        }
                        this.c_selectedEvent.category = context.category
                    }
                }

                this.c_events.forEach((y) => {
                    this.c_events
                        .filter((x) => x.config.draft)
                        .forEach((i) => {
                            if (
                                i.category != y.category ||
                                i.id == y.id ||
                                (this.c_selectedEvent.parent || this.c_selectedEvent).id != (i.parent || i).id
                            )
                                return

                            var date1 = [moment(newStart), moment(newEnd)]
                            var date2 = [moment(y.start), moment(y.end)]

                            var range = moment.range(date1)
                            var range2 = moment.range(date2)

                            if (range.overlaps(range2)) {
                                collision = y
                            }
                        })
                })

                if (collision && !this.c_selectedEvent.isIndispo) {
                    if (newStart - collision.start < collision.end - newStart) {
                        // TP en haut
                        newStart = collision.start - (this.c_selectedEvent.end - this.c_selectedEvent.start)
                        newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)
                    } else {
                        // Tp en bas
                        newStart = collision.end
                        newEnd = this.c_selectedEvent.end + (newStart - this.c_selectedEvent.start)
                    }
                }

                this.c_events.forEach((y) => {
                    this.c_events
                        .filter((x) => x.config.draft)
                        .forEach((i) => {
                            if (
                                i.category != y.category ||
                                i.id == y.id ||
                                (this.c_selectedEvent.parent || this.c_selectedEvent).id != (i.parent || i).id
                            )
                                return
                            var date1 = [moment(newStart), moment(newEnd)]
                            var date2 = [moment(y.start), moment(y.end)]

                            var range = moment.range(date1)
                            var range2 = moment.range(date2)

                            if (range.overlaps(range2)) {
                                leave = true
                            }
                        })
                })
                if (leave) return

                // Real Cards
                if (!this.c_selectedEvent.config.draft && !this.c_selectedEvent.config.block) {
                    this.moveReal(context, newStart, newEnd)
                    return
                }

                if (this.c_selectedEvent.config.block) {
                    Object.assign(parent, {
                        start: newStart,
                        end: newEnd,
                    })
                    return
                }

                // Draft Cards
                Object.assign(parent.ref_presta, {
                    start: newStart,
                    end: newEnd,
                })
                Object.assign(parent, {
                    start: newStart,
                    end: newEnd,
                })
                parent.list.forEach((l) => {
                    Object.assign(l, {
                        start: newStart,
                        end: newEnd,
                    })
                })
            }
        },

        onMouseUpColumn(context) {
            this.c_move_drag = false
            this.moved = false
        },

        moveReal(context, newStart, newEnd) {
            /** All event timeslots have the same Id.
             *  The idea we need to know the drag (with time ms).
             *  I used the @take to save only the first diff
             */
            let take = true
            //  let relatedTimeslots = this.c_events.filter((x) => )
            this.c_events.forEach((e, index) => {
                if (e.id == this.c_selectedEvent.id) {
                    if (take) {
                        this.diffTime = newStart - e.start
                        take = false
                    }
                    e.start = newStart
                    e.end = newEnd
                    this.c_duration.push({ id: this.c_selectedEvent.id, value: Math.floor((newEnd - newStart) / 1000 / 60) })
                }
            })
        },
        DragAllRelated() {
            // take all related events (timeslot) without the current one.
            let allEvent = this.c_events.filter(
                (ev) => ev.data.order_id == this.c_selectedEvent.data.order_id && ev.id != this.c_selectedEvent.id
            )
            allEvent.forEach((e) => {
                e.start += this.diffTime
                e.end += this.diffTime
            })
        },

        // == Data == //
        async reloadCalendarTimeSlot() {
            // Init
            // console.log("this.c_events", this.c_events);
            const requestDate = Date.now()
            const days = this.getTargetDays()
            const staff_ids = this.c_selectedStaffs.map((x) => x.id) || []
            const space_ids = this.c_selectedSpaces.map((x) => x.id) || []
            const phantom = this.phantom
            // Load data
            const [timeslot, working, schedule] = await Promise.all([
                ApiManager.getAllTimeslotPack(days, staff_ids, space_ids, phantom),
                ApiManager.loadWorkingTime(staff_ids, space_ids, days),
                ApiManager.getEstaInfoForDays(days).catch((err) => console.log('Error:', err)),
            ])

            if (requestDate < this.protectCall2) return
            this.protectCall2 = requestDate
            // console.log("this.c_events 2", this.c_events);

            // Reset all events
            this.c_events = TimeSlotManager.resetNoDraft(this.c_events)
            //  console.log("this.c_events 3", this.c_events);
            if (this.c_move_event) {
                this.c_move_event = TimeSlotManager.deleteDuplicate(this.c_move_event, 'category', 'data', 'id')
                this.c_move_event.forEach((element) => {
                    /**
                     * This condition used to check if this element is already in calender (Current day) or not
                     * Create a couple ids between the item_id and the sttaff id
                     */
                    let condition = this.c_events
                        .map((x) => x.data.id + '-' + JSON.parse(x.category).id)
                        .includes(element.data.id + '-' + JSON.parse(element.category).id)
                    element.data.info.colorCategory = '#ff0000'
                    // console.log('element',element)
                    element.config.display = true

                    if (!condition) this.c_events.push(element)
                })
            }
            // Generate blocks before and after establishement time
            this._generateScheduleBlocs(schedule)

            if (working) {
                // Generate indispo
                this._generateIndispoBlocs(working)

                // Generate blocks before and after working time
                const done = this._generateWorkingBlocs(working)
                // Generate exception block
                this._generateExceptionBlocs(working)
                if (true) {
                    const hideEmptyColumn = this._generateMissingWorkingBlocs(days, done)
                    this.c_hideStaffs = hideEmptyColumn
                } else {
                    this.closeEmptyPlaning(days)
                }
            }
            this.c_events = TimeSlotManager.mergeBlock(this.c_events)

            // insert real timeslot
            const assoc = {}
            timeslot.forEach((day) => {
                for (const data of day.spaces) {
                    const target = this.c_spaces.find((x) => x.id == data.id)
                    if (target)
                        TimeSlotManager.addList(this.c_events, this.c_hideEvents, data.timeslots, target.stringify, assoc, day)
                }
                for (const data of day.staffs) {
                    const target = this.c_staffs.find((x) => x.id == data.id)
                    if (target)
                        TimeSlotManager.addList(this.c_events, this.c_hideEvents, data.timeslots, target.stringify, assoc, day)
                }
            })

            this.c_events = TimeSlotManager.mergeBlock(this.c_events, true)

            // Get calendar time (visible range = opening hours, optionally folded)
            this.lastSchedule = schedule
            this._applyVisibleRange(timeslot)

            // Choose each column size
            this.c_counterConsecColumn = TimeSlotManager.computedMaxBlock(this.c_events)
            this.refreshAutoSizeColumn()
            this.$nextTick(() => {
                this._renderCollapseArrows()
                this._autoScrollToOutOfHours()
                if (!this.autoScrolledToNow) {
                    this.autoScrolledToNow = true
                    this._autoScrollToCurrentTime()
                }
            })
            if (this.c_move_event.length > 0) {
                this.c_selectedEvent = this.c_events.find((x) => x.data.bookingId === this.c_move_event[0].data.bookingId)
            }
            // refresh opened timeslot ?
            if (this.c_reopentTimeslot) {
                this.c_selectedEvent = this.c_events.find((x) => x.data.bookingId === this.c_reopentTimeslot)
                this.c_reopentTimeslot = null
                await this.handledReloadCalendarTimeSlot()
            }
        },
        minutesToTime(minutes) {
            if (minutes >= 1439) return '23:59'
            const hours = Math.floor(minutes / 60)
                .toString()
                .padStart(2, '0')
            const mins = (minutes % 60).toString().padStart(2, '0')
            return `${hours}:${mins}`
        },
        timeToMinutes(timeStr) {
            const [hours, minutes] = timeStr.split(':').map(Number)
            return hours * 60 + minutes
        },
        // True quand l'heure de la cellule est en dehors des horaires d'ouverture
        // (affichée dans un fond teinté quand la plage correspondante est dépliée).
        calc_isOutOfHours(time) {
            if (!this.visibleBounds || !time) return false
            const timeStr = typeof time === 'string' ? time : time.time || ''
            if (!timeStr || typeof timeStr !== 'string') return false
            const t = this.timeToMinutes(timeStr)
            return t < this.visibleBounds.openStart || t >= this.visibleBounds.openEnd
        },
        _loadCollapseState() {
            let stored = null
            try {
                stored = JSON.parse(localStorage.getItem('pp-calendar-collapse-v1') || 'null')
            } catch (e) {
                stored = null
            }
            this.collapseState = stored && typeof stored === 'object' ? stored : {}
        },
        _saveCollapseState() {
            try {
                localStorage.setItem('pp-calendar-collapse-v1', JSON.stringify(this.collapseState))
            } catch (e) {
                /* storage indisponible : l'état reste en mémoire pour la session */
            }
        },
        // Bornes (minutes) d'ouverture par jour, à partir du schedule établissement.
        _scheduleBounds(schedule) {
            const bounds = {}
            if (!Array.isArray(schedule)) return bounds
            schedule.forEach((d) => {
                const key = moment(d.date * 1000).format('YYYY-MM-DD')
                let start = this.timeToMinutes(d.start || '00:00')
                // Borne soir : une fermeture à 00:00 désigne en réalité 23:59.
                let end = this.timeToMinutes(d.end || '23:59')
                if (end === 0) end = 1439
                bounds[key] = { start, end }
            })
            return bounds
        },
        // Réservations (vraies prestations) présentes hors horaires d'ouverture.
        _outOfHoursSource(timeSlots) {
            if (timeSlots && Array.isArray(timeSlots)) {
                const items = []
                timeSlots.forEach((day) => {
                    ;[...(day.spaces || []), ...(day.staffs || [])].forEach((s) => {
                        ;(s.timeslots || []).forEach((ts) => {
                            const x = ts?.timeslot
                            if (x && Array.isArray(x.booking) && x.booking.length > 0) {
                                items.push(x)
                            }
                        })
                    })
                })
                return items
            }
            return (this.c_events || []).filter(
                (e) =>
                    !e.config?.block &&
                    !e.config?.draft &&
                    (String(e.id).startsWith('slot') || e.data?.order_id || e.data?.bookingId)
            )
        },
        _countOutOfHours(bounds, timeSlots) {
            const source = this._outOfHoursSource(timeSlots)
            const counts = {}
            const isRaw = Array.isArray(timeSlots)
            const startOf = (e) => (isRaw ? moment(e.start * 1000) : moment(e.start))
            const endOf = (e) => (isRaw ? moment(e.end * 1000) : moment(e.end))
            source.forEach((e) => {
                if (!isRaw && e.config && e.config.block) return
                const key = startOf(e).format('YYYY-MM-DD')
                const b = bounds[key]
                if (!b) return
                const startMin = this.timeToMinutes(startOf(e).format('HH:mm'))
                const endMin = this.timeToMinutes(endOf(e).format('HH:mm'))
                if (!(key in counts)) counts[key] = { morning: 0, evening: 0 }
                if (startMin < b.start) counts[key].morning += 1
                if (endMin > b.end) counts[key].evening += 1
            })
            return counts
        },
        // Extrêmes réels des réservations hors ouverture, par jour.
        // firstAm = heure (minutes) la plus matinale d'une résa commençant avant l'ouverture.
        // lastPm  = heure (minutes) la plus tardive d'une résa finissant après la fermeture.
        // null si aucune résa hors ouverture sur la plage correspondante du jour.
        _outOfHoursExtremes(bounds, timeSlots) {
            const source = this._outOfHoursSource(timeSlots)
            const isRaw = Array.isArray(timeSlots)
            const normalized = source
                .filter((e) => (isRaw ? true : !(e.config && e.config.block)))
                .map((e) => ({
                    start: isRaw ? e.start * 1000 : moment(e.start).valueOf(),
                    end: isRaw ? e.end * 1000 : moment(e.end).valueOf(),
                }))
            return computeOutOfHoursExtremes(normalized, bounds)
        },
        // Calcule la plage visible (firstTime/lastTime) : heures d'ouverture par défaut,
        // les plages pliées n'affichent que les heures réellement occupées hors-horaires.
        _applyVisibleRange(timeSlots) {
            const schedule = this.lastSchedule || []
            const bounds = this._scheduleBounds(schedule)
            const counts = this._countOutOfHours(bounds, timeSlots)

            const dayKeys = Object.keys(bounds)
            const focusKey = moment(this.c_dateFocus).format('YYYY-MM-DD')

            if (dayKeys.length === 0) {
                const { earliest, latest } = this._reservationExtremes(timeSlots)
                const start = earliest != null ? Math.min(540, earliest) : 540
                const end = latest != null ? Math.max(1200, latest) : 1200
                this.c_firstTime = this.minutesToTime(start)
                this.c_lastTime = this.minutesToTime(end)
                this.visibleBounds = null
                this.collapseCounts = { morning: 0, evening: 0 }
                return
            }

            // Bornes globales d'ouverture (min start, max end) sur les jours affichés.
            let openStart = Infinity
            let openEnd = -Infinity
            dayKeys.forEach((k) => {
                openStart = Math.min(openStart, bounds[k].start)
                openEnd = Math.max(openEnd, bounds[k].end)
            })
            if (openStart === Infinity) openStart = 540
            if (openEnd === -Infinity || openEnd === 0) openEnd = 1200

            const c = counts[focusKey] || { morning: 0, evening: 0 }

            let state = this.collapseState[focusKey]
            if (!state) {
                state = {
                    morning: c.morning === 0,
                    evening: c.evening === 0,
                }
                this.$set(this.collapseState, focusKey, state)
            }

            // Quand replié (state.morning === true), firstMin encadre les résas hors ouverture :
            // l'heure de la 1re résa matinale si elle existe, sinon l'ouverture (ex: 09:00).
            // Quand déplié (state.morning === false), firstMin = 0 (00:00).
            const ext = this._outOfHoursExtremes(bounds, timeSlots)[focusKey] || { firstAm: null, lastPm: null }
            let firstMin = state.morning ? (ext.firstAm !== null ? ext.firstAm : openStart) : 0

            // Quand replié (state.evening === true), lastMin encadre les résas hors ouverture :
            // l'heure de fin de la dernière résa du soir si elle existe, sinon la fermeture (ex: 20:00).
            // Quand déplié (state.evening === false), lastMin = 1439 (23:59).
            let lastMin = state.evening ? (ext.lastPm !== null ? ext.lastPm : openEnd) : 1439

            this.c_firstTime = this.minutesToTime(firstMin)
            this.c_lastTime = this.minutesToTime(lastMin)
            this.visibleBounds = { openStart, openEnd, focusKey }
            this.collapseCounts = { morning: c.morning, evening: c.evening }
        },
        // Bornes (minutes) min start / max end des réservations réelles.
        _reservationExtremes(timeSlots) {
            const source = this._outOfHoursSource(timeSlots)
            const isRaw = Array.isArray(timeSlots)
            let earliest = null
            let latest = null
            source.forEach((e) => {
                if (!isRaw && e.config && e.config.block) return
                const s = isRaw ? moment(e.start * 1000) : moment(e.start)
                const en = isRaw ? moment(e.end * 1000) : moment(e.end)
                const sMin = this.timeToMinutes(s.format('HH:mm'))
                const eMin = this.timeToMinutes(en.format('HH:mm'))
                if (earliest === null || sMin < earliest) earliest = sMin
                if (latest === null || eMin > latest) latest = eMin
            })
            return { earliest, latest }
        },
        toggleCollapse(which) {
            const key = moment(this.c_dateFocus).format('YYYY-MM-DD')
            const state = this.collapseState[key] || { morning: true, evening: true }
            const newState = {
                ...state,
                [which]: !state[which],
            }
            this.$set(this.collapseState, key, newState)
            this._saveCollapseState()
            this._applyVisibleRange()
            this.lastAutoScrollDate = null
            this.$nextTick(() => {
                this._renderCollapseArrows()
                if (!newState[which]) {
                    this._autoScrollToOutOfHours()
                }
            })
        },
        _autoScrollToOutOfHours() {
            if (!this.visibleBounds) return
            const key = this.visibleBounds.focusKey
            if (this.lastAutoScrollDate === key) return
            const state = this.collapseState[key] || { morning: true, evening: true }
            const isUnfolded = !state.morning || !state.evening
            if (!isUnfolded) return

            // Scroller automatiquement jusqu'à l'heure de la première réservation du jour si les horaires hors ouvertures sont dépliés
            const target =
                this._firstOutOfHoursEvent(key, 'morning') ||
                this._firstEventOfDay(key) ||
                this._firstOutOfHoursEvent(key, 'evening')
            if (target == null || !this.$refs.calendar || typeof this.$refs.calendar.scrollToTime !== 'function') return
            this.lastAutoScrollDate = key
            const m = moment(target.start)
            this.$nextTick(() => {
                try {
                    this.$refs.calendar.scrollToTime(m.hour(), m.minute())
                } catch (e) {
                    /* composant pas encore prêt */
                }
            })
        },
        _autoScrollToCurrentTime() {
            // Positionner l'écran sur l'heure courante (au niveau de la ligne violette), uniquement à l'ouverture du calendrier
            if (this.c_dateFocus !== moment().format('YYYY-MM-DD')) return
            if (!this.$refs.calendar || typeof this.$refs.calendar.scrollToTime !== 'function') return
            const now = this.nowTime
            this.$nextTick(() => {
                try {
                    this.$refs.calendar.scrollToTime(now.hour(), now.minute())
                } catch (e) {
                    /* composant pas encore prêt */
                }
            })
        },
        _firstEventOfDay(dateKey) {
            const realEvents = (this.c_events || [])
                .filter(
                    (e) =>
                        !e.config?.block &&
                        !e.config?.draft &&
                        (String(e.id).startsWith('slot') || e.data?.order_id || e.data?.bookingId)
                )
                .filter((e) => moment(e.start).format('YYYY-MM-DD') === dateKey)
                .sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf())
            return realEvents.length > 0 ? realEvents[0] : null
        },
        _firstOutOfHoursEvent(dateKey, which) {
            if (!this.visibleBounds) return null
            const { openStart, openEnd } = this.visibleBounds
            const realEvents = (this.c_events || [])
                .filter(
                    (e) =>
                        !e.config?.block &&
                        !e.config?.draft &&
                        (String(e.id).startsWith('slot') || e.data?.order_id || e.data?.bookingId)
                )
                .filter((e) => moment(e.start).format('YYYY-MM-DD') === dateKey)

            return (
                realEvents
                    .filter((e) => {
                        const s = this.timeToMinutes(moment(e.start).format('HH:mm'))
                        const en = this.timeToMinutes(moment(e.end).format('HH:mm'))
                        return which === 'morning' ? s < openStart : en > openEnd
                    })
                    .sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf())[0] || null
            )
        },
        // Inscrit une MutationObserver sur la racine du calendrier : dès que Vuetify
        // reconstruit la gouttière des heures (changement de plage/trame/colonnes), les
        // flèches injectées sont effacées — l'observateur les ré-injecte aussitôt.
        _ensureCollapseObserver() {
            if (this.collapseObserverSetup) return
            const cal = this.$refs.calendar
            const root = cal && cal.$el ? cal.$el : null
            if (!root) return
            this.collapseObserverSetup = true
            this.collapseObserver = new globalThis.MutationObserver(() => {
                if (this._isRenderingArrows) return
                const body = globalThis.document.querySelector('.v-calendar-daily__intervals-body')
                if (body && !body.querySelector('.cv3-collapse-arrow') && this.visibleBounds) {
                    this._renderCollapseArrows()
                }
            })
            this.collapseObserver.observe(root, { childList: true, subtree: true })
        },

        _renderCollapseArrows() {
            const body = globalThis.document.querySelector('.v-calendar-daily__intervals-body')
            if (!body || !this.visibleBounds) return
            this._isRenderingArrows = true

            // Retire d'éventuels boutons orphelins ou précédents avant re-render
            body.querySelectorAll('.cv3-collapse-arrow').forEach((el) => el.remove())

            const { openStart, openEnd } = this.visibleBounds
            const key = moment(this.c_dateFocus).format('YYYY-MM-DD')
            const state = this.collapseState[key] || { morning: true, evening: true }
            const c = this.collapseCounts || { morning: 0, evening: 0 }

            // Plage du matin repliable (il y a des heures avant l'ouverture).
            if (openStart > 0) {
                const collapsed = state.morning
                const hasResa = c.morning > 0
                // Sens et compteur selon les spécifications :
                // - Replié (collapsed = true) : ▲ (avec compteur '▲ 2' si réservations masquées)
                // - Déplié (collapsed = false) : ▼ (sans compteur, flèche au même emplacement en haut)
                this._mountArrow(body, 'morning', '7px', collapsed ? '▲' : '▼', collapsed && hasResa, c.morning)
            }
            // Plage du soir repliable (il y a des heures après la fermeture).
            if (openEnd < 1439) {
                const collapsed = state.evening
                const hasResa = c.evening > 0
                // Sens et compteur selon les spécifications :
                // - Replié (collapsed = true) : ▼ (avec compteur '▼ 2' si réservations masquées)
                // - Déplié (collapsed = false) : ▲ (sans compteur, flèche au même emplacement en bas)
                this._mountArrow(body, 'evening', 'calc(100% - 7px)', collapsed ? '▼' : '▲', collapsed && hasResa, c.evening)
            }

            this.$nextTick(() => {
                this._isRenderingArrows = false
            })
        },
        // Borne la position verticale de la flèche pour qu'elle reste entièrement
        // visible au bord de la grille (repliée) tout en restant centrée sur la
        // limite ouverture/fermeture quand la plage correspondante est dépliée.
        _arrowTop(percent) {
            const offset = 3
            return Math.max(offset, Math.min(100 - offset, percent))
        },
        _mountArrow(body, which, top, glyph, hasResa, count) {
            const btn = globalThis.document.createElement('button')
            btn.type = 'button'
            btn.className = 'cv3-collapse-arrow' + (hasResa ? ' has-resa' : '')
            btn.style.position = 'absolute'
            btn.style.top = `${top}`
            btn.style.left = '50%'
            btn.style.transform = 'translateX(-50%) translateY(-50%)'
            btn.style.zIndex = '20'
            btn.setAttribute('data-which', which)
            btn.innerHTML = ''
            const span = globalThis.document.createElement('span')
            span.className = 'cv3-collapse-arrow-glyph'
            span.textContent = glyph
            btn.appendChild(span)
            if (hasResa) {
                const badge = globalThis.document.createElement('span')
                badge.className = 'cv3-collapse-arrow-count'
                badge.textContent = String(count)
                btn.appendChild(badge)
            }
            btn.addEventListener('click', (e) => {
                e.stopPropagation()
                this.toggleCollapse(which)
            })
            body.appendChild(btn)
        },

        _generateScheduleBlocs(res) {
            res.forEach((d) => {
                const day = moment(d.date * 1000).format('YYYY-MM-DD')
                const insert = (cat, d1, d2) => {
                    TimeSlotManager.addEstablishmentBlock(
                        this.c_events,
                        moment(d1, 'YYYY-MM-DD HH:mm').valueOf(),
                        moment(d2, 'YYYY-MM-DD HH:mm').valueOf(),
                        cat.stringify
                    )
                }
                this.c_selectedStaffs.forEach((x) => {
                    insert(x, `${day} 00:00`, `${day} ${d.start}`)
                    insert(x, `${day} ${d.lunch_start}`, `${day} ${d.lunch_end}`)
                    insert(x, `${day} ${d.end}`, `${day} 23:59`)
                })
                this.c_selectedSpaces.forEach((x) => {
                    insert(x, `${day} 00:00`, `${day} ${d.start}`)
                    insert(x, `${day} ${d.lunch_start}`, `${day} ${d.lunch_end}`)
                    insert(x, `${day} ${d.end}`, `${day} 23:59`)
                })
            })
        },

        _generateIndispoBlocs(workingTime) {
            const insert = (start, end, cat, id, name, text, recId, rec, status, text_exception) => {
                TimeSlotManager.addIndispoBlock(
                    this.c_events,
                    moment(start, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    moment(end, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    cat,
                    id,
                    name,
                    text,
                    recId,
                    rec,
                    status,
                    text_exception
                )
            }
            if (workingTime.planning.length > 0)
                workingTime.planningsException.forEach((h) => {
                    const staff = this.c_staffs.find((x) => x.id == h.user_id)
                    if (!staff) return // ressource non chargée/filtrée → on ignore au lieu de crasher
                    insert(
                        `${h.start}`,
                        `${h.end}`,
                        staff.stringify,
                        h.id,
                        'staff',
                        h.text,
                        h.recurence_id,
                        h.rec,
                        h.status,
                        h.nature_type
                    )
                })
            workingTime.planningsExceptionSpace.forEach((h) => {
                const space = this.c_spaces.find((x) => x.id == h.space_id)
                if (!space) return
                insert(`${h.start}`, `${h.end}`, space.stringify, h.id, 'space', h.text, h.recurence_id, h.rec)
            })
        },

        closeEmptyPlaning(days) {},

        _generateWorkingBlocs(workingTime) {
            let done = {}
            const insert = (start, end, cat, launch, id) => {
                TimeSlotManager.addWorkingTime(
                    this.c_events,
                    moment(start, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    moment(end, 'YYYY-MM-DD HH:mm:ss').valueOf(),
                    cat,
                    launch,
                    id
                )
            }

            workingTime.planning.staffs.forEach((h) => {
                const date = moment.utc(h.date, 'YYYY-MM-DD').valueOf() / 1000
                if (!done[date]) done[date] = {}
                if (done[date] && !done[date][h.user_id]) done[date][h.user_id] = true

                const staff = this.c_staffs.find((x) => x.id == h.user_id)
                if (!staff) return // praticien non chargé/filtré → on ignore au lieu de crasher

                // start - morning block
                insert(`${h.date} 00:00:00`, `${h.date} ${h.start}`, staff.stringify)

                // launch block
                if (`${h.date} ${h.lunch_start}` !== `${h.date} ${h.lunch_end}`) {
                    insert(`${h.date} ${h.lunch_start}`, `${h.date} ${h.lunch_end}`, staff.stringify, true, h.id)
                }

                // end - afternoon block
                insert(`${h.date} ${h.end}`, `${h.date} 23:59:59`, staff.stringify)
            })

            workingTime.planning.spaces.forEach((h) => {
                const date = moment.utc(h.date, 'YYYY-MM-DD').valueOf() / 1000
                if (!done[date]) done[date] = {}
                if (done[date] && !done[date][h.space_id]) done[date][h.space_id] = true

                const space = h.space_id ? this.c_spaces.find((x) => x.id == h.space_id) : null
                if (!space) return // espace non chargé/filtré → on ignore au lieu de crasher

                // start - morning block
                insert(`${h.date} 00:00:00`, `${h.date} ${h.start}`, space.stringify)

                // launch block
                if (`${h.date} ${h.lunch_start}` !== `${h.date} ${h.lunch_end}` && h.lunch_start && h.lunch_end) {
                    insert(`${h.date} ${h.lunch_start}`, `${h.date} ${h.lunch_end}`, space.stringify, true, h.id)
                }

                // end - afternoon block
                insert(`${h.date} ${h.end}`, `${h.date} 23:59:59`, space.stringify)
            })
            return done
        },

        _generateExceptionBlocs(workingTime) {
            const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

            workingTime.planningsEstablishement.forEach((h) => {
                this.c_selectedStaffs.forEach((x) => {
                    TimeSlotManager.addEstablishmentException(
                        this.c_events,
                        getDate(`${h.start}`),
                        getDate(`${h.end}`),
                        x.stringify
                    )
                })
                this.c_selectedSpaces.forEach((x) => {
                    TimeSlotManager.addEstablishmentException(
                        this.c_events,
                        getDate(`${h.start}`),
                        getDate(`${h.end}`),
                        x.stringify
                    )
                })
            })
        },

        _generateMissingWorkingBlocs(days, done) {
            const getDate = (str) => moment(str, 'YYYY-MM-DD HH:mm:ss').valueOf()

            const hide = []
            days.forEach((d) => {
                this.c_selectedStaffs.forEach((s) => {
                    if (!done[d] || !done[d][s.id]) {
                        TimeSlotManager.addWorkingTime(
                            this.c_events,
                            getDate(`${moment(d * 1000).format('YYYY-MM-DD')} 00:00:00`),
                            getDate(`${moment(d * 1000).format('YYYY-MM-DD')} 23:59:59`),
                            this.c_staffs.find((x) => x.id == s.id).stringify
                        )
                        const target = hide.find((h) => h.id === s.id)
                        if (target) target.count -= 1
                        else
                            hide.push({
                                id: s.id,
                                count: days.length - 1,
                            })
                    }
                })
            })
            return hide
        },
        // == //

        // == Utils == //
        getTargetDays() {
            const targetsDays = []
            for (let i = 0; i < this.c_nbOfDay; i++)
                targetsDays.push(
                    moment
                        .utc(this.c_dateFocus)
                        .utcOffset(0)
                        .set({
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                        })
                        .add(i, 'days')
                        .valueOf() / 1000
                )
            return targetsDays
        },

        // == Preset == //
        async applyPreset() {
            const target = this.c_presets.find((x) => x.name == this.c_selectedPresetName)
            if (!target) return
            // [staff]
            const newStaffs = []
            target.config.staffs.forEach((s) => {
                const wanted = this.c_staffs.find((x) => x.id === s)
                if (wanted) newStaffs.push(wanted)
                else console.warn(`[preset] - staff not found ${s}`)
            })
            // [space]
            const newSpaces = []
            if (paramSpace) {
                const Pspace = this.c_spaces.find((x) => x.id == paramSpace)
                if (Pspace && target.config.spaces.findIndex((x) => x == paramSpace) == -1) {
                    newSpaces.push(Pspace)
                }
            }
            target.config.spaces.forEach((s) => {
                const wanted = this.c_spaces.find((x) => x.id === s)
                if (wanted) newSpaces.push(wanted)
                else console.warn(`[preset] - space not found ${s}`)
            })
            // [Assign]
            this.c_selectedStaffs = newStaffs
            this.c_selectedSpaces = newSpaces
            this.c_nbOfDay = target.config.nbOfDay
            this.c_slideValueX = target.config.slideValueX
            this.c_newLogin = target.config.newLogin
            this.c_slideValueY = target.config.slideValueY
            this.c_timeIntervalMinutes = parseInt(target.config.timeIntervalMinutes)
        },

        resetPreset() {
            this.c_selectedStaffs = []
            this.c_selectedSpaces = []
            this.c_nbOfDay = 1
            this.c_slideValueX = 0
            this.c_newLogin = false
            this.c_slideValueY = 4
            this.c_timeIntervalMinutes = 30
        },

        async loadTargetedTimeslot() {
            await ApiManager.getTimeslotInfo(parseInt(this.c_query.timeslot)).then(async (res) => {
                const timeslot = await ApiManager.getAllTimeSlotOfBooking(res.booking.id)

                timeslot.forEach((t) => {
                    t.staff.forEach((s) => {
                        if (!this.c_selectedStaffs.find((x) => x.id == s.id)) {
                            const target = this.c_staffs.find((x) => x.id == s.id)
                            if (target) {
                                target.tmp = true
                                this.c_selectedStaffs.push(target)
                            }
                        }
                    })

                    if (!this.c_selectedSpaces.find((x) => x.id == t.timeslot[0].space.id)) {
                        const target = this.c_spaces.find((x) => x.id == t.timeslot[0].space.id)
                        if (target) {
                            target.tmp = true
                            this.c_selectedSpaces.push(target)
                        }
                    }
                })
                const event = this.c_events.find((x) => x.id === `slot-${this.c_query.timeslot}`)
                if (event) {
                    this.c_selectedEvent = event
                    this.c_showModal = true
                }
            })
        },
        getTicketNbr(booking, prestation_id) {
            return ActivityManager.getTicketNbr(booking, prestation_id)
        },

        nbContributorTotal(event) {
            return event.data.info.nb_contributor
        },
        setTotalCMDDetails() {
            this.getTotalCMDDetails = ActivityManager.getTotalCMDDetails(this.selectedContext.event)
        },
        startIntro() {
            introJs()
                .setOptions({
                    showBullets: false,
                    doneLabel: 'Compris',
                    steps: [
                        {
                            element: document.querySelector('#reservations_intro'),
                            intro: "Cette fenêtre vous permet de voir les réservations associées à ce créneau, de consulter le nombre de personnes par rapport à la capacité maximale, de vérifier le montant payé par rapport au montant attendu et d'afficher le nom et le prénom du réservant .",
                        },
                    ],
                })
                .start()
        },
        showAcceptDeclineReservation(booking) {
            // let isTemporary = false
            // console.log('bookingsss', bookings)
            // bookings.forEach((booking) => {
            //     if (booking.status == -7) {
            //         isTemporary = true
            //     }
            // })
            // return isTemporary
            return booking.status == -7
        },
        acceptAllRelatedReservations(context) {
            //console.log('acceptReservation', context, this.event)
            this.acceptationLoading.accept = true
            let timeslotId = context.event.id.split('-')[1]
            ApiManager.acceptAllRelatedReservations(timeslotId)
                .then((data) => {
                    this.acceptationLoading.accept = false
                    this.showAcceptDeclineOptions = false
                    this.handledReloadCalendarTimeSlot()
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },

        acceptReservation(booking) {
            // console.log('acceptReservation', booking)
            this.acceptationLoading.accept = true

            ApiManager.acceptReservation(booking.id)
                .then((data) => {
                    this.acceptationLoading.accept = false
                    this.showAcceptDeclineOptions = false
                    this.handledReloadCalendarTimeSlot()
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },

        declineAllRelatedReservations(context) {
            // console.log('acceptReservation', context, this.event)
            this.acceptationLoading.decline = true

            let timeslotId = context.event.id.split('-')[1]
            ApiManager.declineAllRelatedReservations(timeslotId)
                .then((data) => {
                    this.acceptationLoading.decline = false
                    this.showAcceptDeclineOptions = false
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },
        declineReservation(booking) {
            // console.log('acceptReservation', booking)
            this.acceptationLoading.decline = true

            ApiManager.declineReservation(booking.id)
                .then((data) => {
                    this.acceptationLoading.decline = false
                    this.showAcceptDeclineOptions = false
                    this.handledReloadCalendarTimeSlot()
                })
                .catch((err) => {
                    this.showAcceptDeclineOptions = true
                    this.acceptationError = ' '
                })
        },
    },
}
</script>

<style scoped>
@import './_style/Calendar.css';

::v-deep .v-application--wrap {
    height: 83vh;
}

/* Scrollbars visibles sur la grille planning.
   Le calendrier Vuetify (type category) fait ~20000px de large avec 100 colonnes :
   sa scrollbar verticale native tombe hors écran, tout à droite. On fait donc porter
   le défilement VERTICAL par le conteneur .horizontal-scroll (largeur = viewport),
   dont la barre verticale s'affiche au bord droit visible ; la barre horizontale
   reste en bas. Le calendrier lui-même ne scrolle plus en interne. */
/* Le conteneur scrollable doit remplir EXACTEMENT la zone visible (ne pas dépasser
   en bas), sinon son bord inférieur — où s'affiche la scrollbar horizontale — passe
   sous l'écran et est rogné par le parent overflow:hidden. */
.fixed-max-height {
    flex: 1 1 auto;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;
}
.horizontal-scroll {
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #b9bcc2 #f1f1f1;
}
.horizontal-scroll::-webkit-scrollbar {
    width: 12px;
    height: 12px;
}
.horizontal-scroll::-webkit-scrollbar-thumb {
    background: #b9bcc2;
    border-radius: 6px;
    border: 3px solid transparent;
    background-clip: content-box;
}
.horizontal-scroll::-webkit-scrollbar-thumb:hover {
    background: #9aa0a6;
    background-clip: content-box;
}
.horizontal-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}
/* Le défilement vertical ET horizontal est porté par .horizontal-scroll. Le calendrier
   lui-même ne doit donc PAS scroller : sinon une 2e barre verticale (redondante) s'affiche
   à son bord droit. On met overflow sur les DEUX axes à visible — indispensable car
   `overflow-y: visible` seul est recalculé en `auto` par le navigateur tant que
   overflow-x n'est pas visible (règle CSS), ce qui réintroduit la barre. */
::v-deep .v-calendar-category {
    max-height: none !important;
    overflow: visible !important;
}

.v-event-timed {
    border-radius: 0px !important;
}

.v-calendar-category .v-calendar-daily__day,
.v-calendar-category .v-calendar-category__column {
    min-width: 220px !important;
}

.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header {
    min-width: 220px !important;
}

.v-calendar-category .v-calendar-category__columns .v-calendar-category__column-header:last-child {
    border-right: none;
}

.v-calendar-category .v-calendar-category__category {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    overflow: hidden;
}

.v-calendar-category .v-calendar-category__category span {
    font-family: 'Poppins Medium', sans-serif;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
}

.v-calendar-staff {
    color: #4b5b6b;
}

.v-calendar-staff span {
    color: #4b5b6b !important;
    font-weight: 500;
}

.v-calendar-space {
    color: #94a3b8;
    font-family: Poppins Regular;
    font-size: 12px;
}

.v-calendar-space span {
    color: #191d41 !important;
    letter-spacing: 0.01em;
}
.dark .v-calendar-space span {
    color: #fff !important;
}
.v-calendar-category .v-calendar-category__category span::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 1.5px;
    width: 20px;
    background: #7d2dbd;
}
.v-calendar-daily__day:nth-child(2) {
    .v-current-time {
        &.first::before {
            content: '';
            position: absolute;
            background-color: #7d2dbd;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-top: -5px;
            margin-left: -6.5px;
            z-index: 10;
        }
    }
}

.v-current-time {
    height: 2px;
    background-color: #7d2dbd;
    position: absolute;
    left: -1px;
    right: 0;
    pointer-events: none;
    z-index: 12;
}

.v-calendar-daily__intervals-body {
    position: relative;
}

.cv3-out-hours {
    background-color: rgba(125, 45, 189, 0.08) !important;
}

.cv3-collapse-arrow {
    position: absolute !important;
    left: 50% !important;
    transform: translateX(-50%) translateY(-50%) !important;
    z-index: 20 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    cursor: pointer !important;
    color: #7d2dbd !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    transition:
        color 0.15s ease,
        opacity 0.15s ease !important;
    user-select: none !important;

    &:hover {
        color: #6521a0 !important;
        opacity: 1 !important;
    }

    &.has-resa {
        color: #7d2dbd !important;

        .cv3-collapse-arrow-count {
            color: #7d2dbd !important;
        }
    }

    .cv3-collapse-arrow-glyph {
        font-size: 13px !important;
        font-weight: 700 !important;
        line-height: 1 !important;
        color: #7d2dbd !important;
    }

    .cv3-collapse-arrow-count {
        font-size: 12px !important;
        font-weight: 700 !important;
        color: #7d2dbd !important;
        line-height: 1 !important;
    }
}

.v-event-timed-container {
    margin-right: 0px !important;
}

.theme--light.v-calendar-events .v-event-timed {
    border: none !important;
}

.v-calendar-category .v-calendar-daily__head {
    z-index: 2001 !important;
    height: auto;
}

.v-calendar-staff {
    color: #4b5b6b;
}

.v-calendar-space {
    color: #94a3b8;
    font-family: Poppins Regular;
    font-size: 12px;
}
</style>
<style scoped>
.original-price {
    text-decoration: line-through;
    color: red;
}

.small-original-price {
    font-size: 10px;
    text-decoration: line-through;
    color: red;
}

.s-price {
    display: flex;
}

.vapp {
    margin: 0 !important;
}
::v-deep .v-calendar-daily_head-day-label {
    padding: 6px 0px 6px 8px !important;
}
</style>
